/**
 * Section Header
 */

// Vendors
import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';

// Create waypoint
$('.section__header').each(
  (index, element) =>
    new Waypoint({
      element: $(element),
      offset: '75%',
      handler: function (direction) {
        if (direction !== 'down') return;

        $(this.element).addClass('section__header--in-view');
      }
    })
);
